export default __webpack_public_path__ + "static/media/HRP1.71fd0618.jpg";